// extracted by mini-css-extract-plugin
export default {"imageWrapper":"DN-z","twoColumnImage":"EN-z"};